import { QueryFunctionContext } from '@tanstack/react-query';

import { AccessRequestsApiListAccessRequestsRequest } from '../../api/v1';
import useListQuery from '../../utils/use-list-query';

import { API_LIMIT } from '../../utils/constants';
import useAccessRequestsApi from './use-access-requests-api';

export const QUERY_KEY = 'listAccessRequests';

export default function useListAccessRequests({
  limit,
  skip,
  refetch,
  ...props
}: AccessRequestsApiListAccessRequestsRequest & {
  refetch?: number;
}) {
  const api = useAccessRequestsApi();

  const fetch = async ({ pageParam: skipParam = 0 }: QueryFunctionContext) =>
    api.listAccessRequests({
      ...props,
      limit: limit || API_LIMIT,
      skip: skipParam,
    });

  return useListQuery({
    fetchMethod: fetch,
    queryKey: [QUERY_KEY, props],
    initialOffset: skip,
    refetch,
  });
}
